import { call, put, takeLatest } from 'redux-saga/effects';
import { ChatAction, Response } from './types';
import { chatActions as actions } from '.';
import { API } from './constants';
import { request } from '../../../helpers/request';

export function* getMessagesGenerator({ payload: data }: ChatAction) {
  try {
    const response: Response = yield call(request, API.GET_MESSAGES, { id: data }, true);
    if (response.success) {
      yield put(actions.getMessagesSuccess(response.data));
    } else {
      yield put(actions.getMessagesFailed());
    }
  } catch (err) {
    yield put(actions.getMessagesFailed());
  }
}

export function* chatSaga() {
  yield takeLatest(actions.getMessages.type, getMessagesGenerator);
}
export default chatSaga;
